import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-tag-editor',
    templateUrl: './tag-editor.component.html',
    styleUrls: ['./tag-editor.component.scss'],
    standalone: true,
    imports: [NgFor, FormsModule],
})
export class TagEditorComponent {
	@Input() tags: string[] = []
	newTag: string = ''

	@Output() tagsUpdated = new EventEmitter<string[]>()

	addTag() {
		if (this.newTag && !this.tags.includes(this.newTag)) {
			this.tags.push(this.newTag)
			this.tagsUpdated.emit(this.tags)
			this.newTag = ''
		}
	}

	removeTag(tag: string) {
		const index = this.tags.indexOf(tag)
		if (index > -1) {
			this.tags.splice(index, 1)
			this.tagsUpdated.emit(this.tags)
		}
	}
}
